 const newsData = [
  {
    slug: "kindertag",

    title: "Besonderes Kinderbild zum 23. April",

    subtitle:
      "Ein kreativer Tag voller Farben, Freude und interkultureller Begegnung",

    date: "2025-04-23",

    content: [
      "Anlässlich des Nationalfeiertags und Kindertags am 23. April, der in der Türkei als „Tag der Nationalen Souveränität und des Kindes“ gefeiert wird, gestalteten unsere Schülerinnen und Schüler ein ganz besonderes Kunstwerk.",
      "Unter der Anleitung unserer Kunstlehrerin entstand ein farbenfrohes Gemeinschaftsbild, das die Freundschaft und Vielfalt aller Kinder der Welt symbolisiert. Die Komposition spiegelt unterschiedliche Kulturen, Werte und Lebensfreude wider. Sie ist ein Ausdruck für Zusammenhalt und Frieden.",
      "Das Kunstwerk wurde im Rahmen einer gemeinsamen Veranstaltung mit dem Türkischen Konsulat im Rathaus Frankfurt ausgestellt. Ziel dieser besonderen Aktion war es, den Kindern nicht nur die Freude am Feiertag, sondern auch den kulturellen Austausch näherzubringen.",
      "An der Veranstaltung nahmen Vertreterinnen und Vertreter des Ukrainischen Konsulats, des Türkischen Konsulats sowie der Bürgermeister der Stadt Frankfurt teil. Sie gratulierten den Schülerinnen und Schülern herzlich zu ihrem beeindruckenden Werk, das von allen Gästen mit großer Begeisterung aufgenommen wurde.",
      "Unsere Schule wird auch in Zukunft die künstlerischen Talente der Kinder fördern und ihnen Räume bieten, um Kreativität, interkulturelles Verständnis und zu erleben."
    ]
  },

  {
    slug: "frankfurt-tafel-kreativ",

    title: "Frankfurt-Tafel kreativ",

    subtitle:
      "Ein gemeinsames Kunstprojekt voller Kreativität, Teamgeist und Farbe!",

    date: "2024-11-21",

    content: [
    "Unsere Schüler*innen haben unter der Anleitung unserer Kunstlehrerin ein spannendes Projekt durchgeführt: Sie haben eigene kleine Leinwände gestaltet, die zusammen ein großes Bild von Frankfurt ergeben.",
    "Jede Leinwand zeigt die Kreativität und Fantasie der Schüler*innen und bringt ihre individuellen Ideen zum Ausdruck. Aus allen einzelnen Bildern entstand eine beeindruckende gemeinsame Komposition, die die Stadt Frankfurt in bunten Farben darstellt.",
    "Dieses Projekt fördert Teamarbeit, kreativen Ausdruck und die Freude am gemeinsamen Gestalten. Es zeigt erneut, wie Kunst unsere Schule bereichert und verbindet."
    ]
  },

  {
     slug: "welttag-des-buches",

      title: "Welttag des Buches und der Autorenrechte",

      subtitle:
        "",

      date: "2026-04-23",

      content: [
      "Anlässlich des Welttages des Buches und der Autorenrechte am 23.04.2026 fand an unserer Schule ein vielseitig gestalteter Projektnachmittag statt, der die Bedeutung von Literatur, Kreativität und geistigem Eigentum in den Mittelpunkt stellte. Im Rahmen zahlreicher interaktiver Angebote erhielten unsere Schülerinnen und Schüler die Möglichkeit, Bücher und ihre Entstehung aus neuen Perspektiven kennenzulernen sowie ihre Begeisterung für das Lesen weiterzuentwickeln.",
      "In unterschiedlichen Workshops und Präsentationen setzten sich die Teilnehmenden unter anderem mit der Entstehung eines Buches, dem Thema Urheberrechte sowie dem literarischen Erbe bedeutender Autoren wie Shakespeare und Cervantes auseinander. Ergänzt wurde das Programm durch ein Buch-Speed-Dating, bei dem Lieblingsbücher vorgestellt, persönliche Leseempfehlungen ausgetauscht und neue Titel entdeckt werden konnten.",
      "Auch unsere Schulbibliothek bot einen kreativen Beitrag mit dem Workshop „Don’t judge a book by its cover! – Oder doch?“, in dem die Wirkung von Buchcovern analysiert und eigene Gestaltungsideen praktisch umgesetzt wurden. Darüber hinaus präsentierte unsere Ausstellung KI-generierte Illustrationen zu Szenen aus der Schullektüre sowie zweisprachige Lesezeichen, die von unseren Schülerinnen und Schülern gestaltet wurden.",
      "Ein besonderes Highlight stellte zudem das Bücher-Blind-Date dar, bei dem verpackte Bücher anhand kurzer Hinweise ausgewählt werden konnten und so auf spannende Weise neue Lektüre entdeckt wurde.",
      "Der Projektnachmittag verband damit kulturelle Bildung, kreative Entfaltung und die Freude am Lesen und bot einen inspirierenden Beitrag zu unserem schulischen Bildungsauftrag.",
      ]
  },
  {
        slug: "erstklässler-2025",

        title: "Willkommen, Erstklässler!",

        subtitle:
          "Ein unvergesslicher erster Tag voller Spaß, Lernen und neuer Freunde!",

        date: "2025-08-19",

        content: [
        "Das Schuljahr 2025/2026 begann an unserer Schule voller Freude und Aufregung. Der erste Schultag unserer Erstklässler wurde sowohl für die Kinder als auch für die Eltern durch einen besonderen Orientierungstag zu einem unvergesslichen Erlebnis.",
        "Zu Beginn des Tages begrüßten unsere Schulleitung und die Klassenlehrer*innen die neuen Schülerinnen und Schüler sowie ihre Eltern. In ihren Ansprachen betonten sie, wie wichtig es ist, dass die Erstklässler einen leichten Einstieg in das Schulleben finden und eine positive, freudvolle Lernerfahrung machen.",
        "Die Viertklässler hatten eine besondere Überraschung vorbereitet, um die neuen Mitschüler*innen willkommen zu heißen. Sie überreichten selbstgestaltete Bilder und kleine Blumen an jeden Erstklässler – ein herzlicher Empfang!",
        "Unsere erste Klasse wurde sorgfältig vorbereitet, damit die Kinder sich schnell einleben und neugierig auf das Lernen werden können. Von den Lernmaterialien bis zu den Spiel- und Arbeitsbereichen wurde alles so gestaltet, dass es die Freude und das Interesse der Kinder unterstützt.",
        "Anschließend wurden alle Eltern in unserer Schule zu kleinen Erfrischungen eingeladen. Bei Kaffee, Tee und Snacks hatten sie die Gelegenheit, sich untereinander und mit den Lehrkräften auszutauschen, Erfahrungen zu teilen und die Aufregung des neuen Schuljahres zu genießen.",
        "So wurde der erste Schultag unserer Erstklässler zu einem unvergesslichen und freudvollen Start – sowohl für die Kinder als auch für die Eltern. Wir wünschen allen Schülerinnen und Schülern ein erfolgreiches, glückliches und lehrreiches Schuljahr voller spannender Entdeckungen!"
        ]
  },
  {
          slug: "herbst-und-kulturfest",

          title: "Herbst- und Kulturfest",

          subtitle:
            "Ein Tag voller Farben, Musik und Freude an unserer Schule",

          date: "2025-09-30",

          content: [
          "In diesem Jahr feierten die Klassen 1 bis 4 gemeinsam ein fröhliches und buntes Herbstfest. Die selbst zubereiteten Köstlichkeiten, die von den Eltern mitgebracht wurden, sowie die Tänze und Lieder unserer Schülerinnen und Schüler verwandelten die Schule in ein wahres Fest der Sinne.",
          "An den liebevoll gestalteten Buffets in der Mensa und in den Klassenräumen kamen alle zusammen, um zu teilen, zu lachen und gemeinsam zu feiern.",
          "Ein herzliches Dankeschön geht an alle Kinder, Lehrkräfte und Eltern, die diesen besonderen Tag möglich gemacht haben. Durch das gemeinsame Gestalten, Teilen und Feiern wurde der Gemeinschaftsgeist unserer Grundschule auf wunderbare Weise spürbar."
          ]
    },
    {
          slug: "muttertag",

          title: "Überraschung zum Muttertag",

          subtitle:
            "Ein Tag voller Freude, Kreativität und Liebe für unsere Mütter",

          date: "2025-05-08",

          content: [
          "Zum Muttertag fand an unserer Grundschule eine besonders liebevolle Aktion statt. Unter der Anleitung unserer Kunstlehrerin gestalteten die Schüler*innen mit viel Begeisterung und Fantasie persönliche Karten.",
          "Mit großer Sorgfalt und Kreativität entstanden kleine Kunstwerke, die nicht nur die Feinmotorik der Kinder förderten, sondern vor allem den Müttern ein Lächeln ins Gesicht zauberten.",
          "Diese schöne Aktion stärkte das Miteinander an unserer Schule und bot den Kindern die Möglichkeit, ihre Zuneigung auf eine ganz persönliche und kreative Weise auszudrücken."
         ]
    },

    {
          slug: "bunte-osteraktion",

          title: "Bunte Osteraktion",

          subtitle:
            "Ein bunter Tag voller Freude und Kreativität!",

          date: "2025-04-18",

          content: [
          "Unsere Erstklässlerinnen und Erstklässler haben unter der Anleitung unserer Kunstlehrerin eine kreative Ostern-Aktion durchgeführt. Die Kinder bemalten mit großer Freude bunte Eier und gestalteten ihre eigenen Osterkörbchen.",
          "Durch diese Aktivität konnten die Schülerinnen und Schüler verschiedene Maltechniken kennenlernen und ihre künstlerischen Fähigkeiten entwickeln. Gleichzeitig erlebten sie, wie schön Teamarbeit und Teilen sein kann. Die entstandenen bunten Körbchen spiegeln die Fantasie und den Einsatz der Kinder auf wunderbare Weise wider.",
          "Während der gesamten Aktivität war die Begeisterung und Freude der Schülerinnen und Schüler deutlich spürbar. Die farbenfrohen Ergebnisse zeigen, wie kreativ sie waren und wie viel Spaß sie an diesem Tag hatten.",
          "Wir gratulieren allen Schülerinnen und unserer Kunstlehrerin zu dieser bunten und gelungenen Aktion!"
     ]
    },

    {
          slug: "kreative-leinwände",

          title: "Kreative Leinwände",

          subtitle:
            "Ein Gemeinschaftsprojekt voller Fantasie, Farbe und Teamgeist",

          date: "2024-12-19",

          content: [
          "In den vergangenen Tagen haben unsere Schülerinnen und Schüler unter der Anleitung unserer Kunstlehrerin ein ganz besonderes Projekt verwirklicht. Alle Schülerinnen und Schüler gestalteten eine kleine weiße Leinwand mit einem individuellen, farbenfrohen Motiv, das Teil eines großen Ganzen wurde: Gemeinsam formen alle Leinwände den Namen unserer Schule.",
          "So entstand ein beeindruckendes Gesamtbild, das nicht nur den kreativen Ausdruck jeder Einzelnen zeigt, sondern auch den Zusammenhalt innerhalb unserer Schulgemeinschaft sichtbar macht.",
          "Dieses Projekt ist ein schönes Beispiel dafür, wie Kunst verbindet, Kreativität, Teamarbeit und die Freude am gemeinsamen Gestalten fördert. Die bunten Leinwände erinnern uns daran, wie vielfältig und lebendig unsere Schule ist."
       ]
    },
    {
          slug: "winterfest",

          title: "Winterfest",

          subtitle:
            "",

          date: "2025-12-17",

          content: [
          "Unser Winterfest bot Schülerinnen und Schülern, Eltern sowie Gästen die Gelegenheit, das Halbjahr in einer festlichen und gemeinschaftlichen Atmosphäre gemeinsam ausklingen zu lassen. Im Mittelpunkt der Veranstaltung stand das vielfältige Engagement unserer Schulgemeinschaft, das sich in einem abwechslungsreichen und gelungenen Programm widerspiegelte.",
          "Besonders hervorzuheben war die Vorstellung unserer Arbeitsgemeinschaften, die ihre erarbeiteten Projekte, kreativen Beiträge und besonderen Fähigkeiten präsentierten. Darüber hinaus sorgten Tanzaufführungen für besondere Höhepunkte des Abends und unterstrichen die Vielseitigkeit sowie das Talent unserer Schülerinnen und Schüler.",
          "Ergänzt wurde das Winterfest durch ein liebevoll organisiertes kulinarisches Angebot, das zum Verweilen und zum gemeinsamen Austausch einlud. Zudem wurde im Rahmen der Veranstaltung eine Spendenaktion durchgeführt, mit der soziales Engagement gefördert und ein wertvoller Beitrag für einen guten Zweck geleistet werden konnte.",
          "Das Winterfest vereinte damit Gemeinschaft, Kreativität und Verantwortungsbewusstsein und bleibt als gelungene Veranstaltung in besonderer Erinnerung."
           ]
    },
    {
          slug: "tag-der-offenen-tur-15-11-2025",

          title: "Tag Der Offenen Tür",

          subtitle:
            "",

          date: "2025-11-15",

          content: [
           ]
    },
    {
          slug: "tag-der-offenen-tur-21-02-2026",

          title: "Tag Der Offenen Tür",

          subtitle:
            "",

          date: "2026-02-21",

          content: [
          "Im Rahmen unseres Tags der offenen Tür durften wir zahlreichen Interessierten die Möglichkeit bieten, unsere Schule und ihr vielfältiges Bildungsangebot persönlich kennenzulernen. Besucherinnen und Besucher erhielten umfassende Einblicke in unsere Grundschule sowie in die integrierte Gesamtschule und konnten sich ein authentisches Bild von unserem schulischen Konzept machen.",
          "Durch abwechslungsreiche Informationsveranstaltungen, bildungsorientierte Mitmach-Aktivitäten und eigens für diesen Anlass organisierte Unterrichtseinheiten wurde erlebbar, wie wir Lernen modern, dynamisch und praxisnah gestalten. Besonders im Mittelpunkt standen dabei die Förderung selbstständigen Arbeitens, die Entwicklung kritischen Denkens sowie die individuelle Entfaltung persönlicher Potenziale.",
          "Der Tag der offenen Tür bot somit nicht nur Gelegenheit zum Kennenlernen unserer Schule, sondern auch einen lebendigen Eindruck davon, wie wir Schülerinnen und Schüler auf ihrem weiteren schulischen und persönlichen Weg nachhaltig begleiten."
           ]
    },
    {
              slug: "frühlingsfest",

              title: "Frühlingsfest",

              subtitle:
                "",

              date: "2026-04-25",

              content: [
              "Ein besonderer Höhepunkt des Schuljahres war unser Frühlingsfest, das am 25. April 2026 stattfand. Bereits im Vorfeld wurden Schülerinnen und Schüler, Eltern sowie Gäste herzlich zu dieser Veranstaltung eingeladen, um gemeinsam einen fröhlichen Nachmittag in unserer Schulgemeinschaft zu verbringen.",
              "Auf dem festlich gestalteten Schulhof erwartete die Besucherinnen und Besucher ein abwechslungsreiches Programm. Im Mittelpunkt standen die vielfältigen Aktivitäten unserer Arbeitsgemeinschaften, die ihre Projekte präsentierten und zahlreiche kreative, sportliche sowie spielerische Mitmachangebote vorbereitet hatten. So konnten alle Gäste einen Einblick in das engagierte Schulleben gewinnen.",
              "Für das leibliche Wohl war mit einem vielfältigen Angebot an Speisen und Getränken bestens gesorgt. In angenehmer Frühlingsatmosphäre bot sich die Gelegenheit zum Verweilen, zum Austausch und zum gemeinsamen Feiern.",
              "Das Frühlingsfest vereinte Gemeinschaft, Kreativität und Freude und bot allen Beteiligten einen gelungenen Nachmittag. Die Veranstaltung bleibt als schönes Beispiel für das lebendige Miteinander an unserer Schule in besonderer Erinnerung."
                ]
        }

];
export default newsData;